import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-517f44fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ihre Auswahl:", -1))
const _hoisted_4 = { class: "chosen-path-segments" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Zusatzoptionen:", -1))
const _hoisted_8 = { class: "chosen-additional-options" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenSegmentsTitles, (segment) => {
          return (_openBlock(), _createElementBlock("li", {
            key: segment.alias
          }, [
            _createElementVNode("span", {
              class: _normalizeClass([segment.isCostExternal ? 'cost-external' : 'cost-internal']),
              innerHTML: _ctx.decodeHtmlEntities(segment.title)
            }, null, 10, _hoisted_5)
          ]))
        }), 128))
      ]),
      (_ctx.chosenAdditionalOptions.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenAdditionalOptions, (option) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: option.id
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([option.isCostExternal ? 'cost-external' : 'cost-internal'])
                  }, _toDisplayString(_ctx.getGroupTitleForOption(option)) + ": ", 3),
                  _createElementVNode("span", {
                    innerHTML: _ctx.decodeHtmlEntities(option.title)
                  }, null, 8, _hoisted_9)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}